var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('b-container',{attrs:{"fluid":""}},[_c('iframe',{attrs:{"src":"/dfr/#/model/list","frameborder":"0","height":"800px","width":"100%"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }